import $ from 'jquery';
import OrdersListView from '../account/views/OrdersListView';
import FlashMessageView from '../common/views/FlashMessageView';
import MasterView from '../common/views/MasterView';
import ProductVisualsView from '../../../Nav/Js/views/ProductVisualsView';
import { MagnificPopup } from '../common/dynamic-imports/MagnificPopup';
import 'component?js-bestSales';
import 'component?js-CategoryNav';
import 'component?js-StrateMacView';
import 'component?js-TabbedList';
// import 'component?js-ProductBuy';
import 'component?js-SearchSideAdvertising';
import 'component?js-productSummaryTrimHeight';
import 'component?js-CartCount';
import 'component?js-VideoPlayer';
import 'component?js-StoreFinderView';
import 'component?js-AudioPlayer';
import 'component?js-ProductBuy-changeQuantity';
import 'component?js-flashSale';
import 'component?js-bf-countdown';
import 'component?js-PubliSticky';
import 'component?js-moreContentNav';
import 'component?js-FlashSales';
import 'component?js-ProductView';
import 'component?js-ProductStimulusChrono';
import 'component?js-PopupInline';
import 'component?js-PopinKoboRedirect';
import 'component?js-TabbedListAnchor';
import 'component?js-NavigationHistory';
import 'component?js-popoverTopVendor';
import 'component?js-searchFnacPlus';
import 'component?js-PubliAccordion';
import 'component?js-PubliFlipCard';
import 'component?js-publiParallax';
import 'component?js-PubliVisuals';
import 'component?js-PubliScrollToAnchor';
import 'component?js-share';
import 'component?js-StrateAsync';
import 'component?js-Overlay';
import 'component?js-select';
import 'component?js-Carousel';
import 'component?js-Header__search-dropdown';
import 'component?js-HeaderTabs';
import NavView from '../common/views/NavView';

/**
 * Instanciate common views and behaviors when DOM is ready.
 * This file is loaded in every pages.
 *
 * @todo Delete temporary variables that are not used anymore outside of the local tests
 */

// deliveryAddressMapPopinTemplate
var $maMain = $('.ma-Main');
if ($maMain.length) {
  new OrdersListView({ el: $maMain, $popinTemplate: $('#deliveryAddressMapPopinTemplate') });
}

// Master view: this view is used for generics components (that is why it is attached to body)
var $body = $('body');
new MasterView({ el: $body });

// init NavView
new NavView({ el: $body });

// sidebar navigation
var sidebarNode = $('.js-Sidebar');
if (sidebarNode.length) {
  $('.Sidebar-nano').nanoScroller({ preventPageScrolling: true, iOSNativeScrolling: true });
}

// Product visuals
// @todo Temporary solution to detect "no image" products
// @see Nav\Core\Product\Header\Left\Visuals.ascx & Nav\Js\views\ProductVisualsView.js for more information
if (
  $('.js-ProductVisuals').length &&
  $('.js-ProductVisuals .js-ProductVisuals-item').first().data('src').indexOf('noscan') === -1
) {
  new ProductVisualsView();
} else {
  $('.js-ProductVisuals .js-ProductVisuals-zoom').remove();
}

// popups ajax legacy
// add close event and popup wrapper for legacy popups
var $popupAjaxLegacy = $('.js-PopupAjaxLegacy');
if ($popupAjaxLegacy.length) {
  const magnificPopup = new MagnificPopup($popupAjaxLegacy, {
    type: 'ajax',
    tError: "<a href='%url%'>La page</a> n'a pas pu être chargée, veuillez réessayer ultérieurement.",
    callbacks: {
      parseAjax: function (mfpResponse) {
        // add popup wrapper
        mfpResponse.data = "<div class='Popup Popup--large Popup--noPadding'>" + mfpResponse.data + '</div>';
      },
      ajaxContentAdded: function () {
        // register close event
        this.content.find('.close').on('click', magnificPopup.close);
      },
    },
  });
}

// flash messages
document.body.appendChild(new FlashMessageView().el);

$('.js-ProductBuyBoxAdh').each(function () {
  if ($(this).nextAll('.js-ProductBuyBoxStd').length !== 0 && $(this).find('.js-ProductBuy-adherentCheckable').length) {
    $('.js-ProductBuy-fnacplusCheckable').prop('checked', true);
  }
});

var $searchInput = $('.js-HeaderSearch-input');
if ($searchInput.length && $searchInput.val().length > 0) {
  $('.js-HeaderSearch-inputClear').addClass('on');
}

/* /PUBLI */
// Ad 300*250 HomePage (iframe)
var $thumbnail = $('.categoryMosaic-thumb');
var $advertisting = $('.categoryMosaic-advertising');
var $advertistingDiv = $('.categoryMosaic-advertising div');

if ($thumbnail.length) {
  // setInterval for IE 9/Edge (fix)
  var counter = 0;
  var looper = setInterval(function () {
    counter++;

    var $window = $(window)
      .on('load resize', function () {
        var height = $thumbnail.height();
        var width = $thumbnail.width();
        var iframeScale = 0;
        $advertisting.css('padding-bottom', height);
        $advertistingDiv.first().css('padding-bottom', height - 16 + 'px');

        if (width >= height) {
          iframeScale = width / 300;
        } else {
          iframeScale = (height - 17) / 250;
        }

        if (iframeScale > 1) {
          iframeScale = 1;
        }

        $advertistingDiv.first().css({
          '-webkit-transform': 'scale(' + iframeScale + ')',
          '-moz-transform': 'scale(' + iframeScale + ')',
          '-ms-transform': 'scale(' + iframeScale + ')',
          transform: 'scale(' + iframeScale + ')',
        });
      })
      .trigger('resize'); //on page load

    if (counter >= 5) {
      clearInterval(looper);
    }
  }, 1000);
}
